/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum IngredientSource {
  ANIMAL = "animal",
  BACTERIA_FUNGI_OR_OTHER_SINGLE_CELL_ORGANISM = "bacteria_fungi_or_other_single_cell_organism",
  MINERAL = "mineral",
  PLANT = "plant",
  SYNTHETIC = "synthetic",
}
